/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { postHandlerAnonymous, stdErrHandlerFactory } from "../../utils/Requests";
import { Blank, ChangePasswordRequest, Effect, OperationSuccess, Setter } from "../../utils/Interfaces";
import { AxiosResponse } from "axios";

export function changePassword(
    primary: string,
    secondary: string,
    newPassword: string,
    dispatch: Dispatch<AnyAction>,
    onPasswordResetSuccess: Effect,
    onPasswordResetFailed: Effect
) {
    postHandlerAnonymous<ChangePasswordRequest, OperationSuccess>(
        `/api/help/change-password/${primary}/${secondary}`,
        { password: newPassword },
        dispatch,
        (response: AxiosResponse<OperationSuccess, any>) => onPasswordResetSuccess(),
        stdErrHandlerFactory(dispatch, onPasswordResetFailed)
    );
}

export function createPasswordChangeRequest(
    userProfile: string,
    dispatch: Dispatch<AnyAction>,
    onSuccess: Effect,
    onError: Effect,
    setLoading: Setter<boolean>
) {
    postHandlerAnonymous<Blank, OperationSuccess>(
        `/api/help/request-password-change/${userProfile}`,
        {},
        dispatch,
        (response: AxiosResponse<OperationSuccess, any>) => onSuccess(),
        stdErrHandlerFactory(dispatch, onError),
        setLoading
    );
}
